import { Injectable } from '@angular/core';
import {
  InsufficientMilesIconType,
  PopupSettingService,
} from '@rd/popup/services/popup-setting/popup-setting.service';

@Injectable({
  providedIn: 'root',
})
export class BnzPopupSettingService extends PopupSettingService {
  // AuthSecureRouteDialog settings
  shouldRenderRegisterLink = false;
  shouldRenderLoginButton = false;
  insufficientMilesIconType: InsufficientMilesIconType = 'warning';
}
